export default __webpack_public_path__ + "static/media/LogoAppMosph.a61286e1.png";